import { Directive, Input } from '@angular/core';
/**
 * Generated class for the RegistrationMessageDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[registration-message]' // Attribute selector
})
export class RegistrationMessageDirective {
  @Input() currentEvent: any;
  constructor() {
  }

  ngOnInit() {
    this.eventCheck(this.currentEvent);
  }

  eventCheck(event: any) {

  }

}



// WEBPACK FOOTER //
// ./src/directives/registration-message/registration-message.ts